export default "__VITE_ASSET__DUpr8QVD__"